export default __webpack_public_path__ + "static/media/breakfast.6bb43d8b.jpg";